import { render, staticRenderFns } from "./ConvenioForm.vue?vue&type=template&id=4b907cfc&scoped=true"
import script from "./ConvenioForm.vue?vue&type=script&lang=js"
export * from "./ConvenioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b907cfc",
  null
  
)

export default component.exports